import { LiturgyItem } from "./types";

export const getComplinePsalmAntiphon = (): LiturgyItem[] => {
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "8.1",
            pointedText: {
                clef: "c5",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Have",
                                        notes: ["2"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "mer",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "cy",
                                        notes: ["2", "1"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "up",
                                        notes: ["2"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "on",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "me,",
                                        notes: ["2"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["1", "2"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "God;",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["3", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hear",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ken",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "un",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "to",
                                        notes: ["2", "1"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: ["2", "3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "prayer.",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    ];
};
